<template>
<div>
    <common-header title="모바일 상품권 사용" :showTitle="true" :showLeftMenu="false" :showBack="true" />
    <main class="pay-egift order-select-main-mymenu">
        <div class="egift-list mymenulist">
            <div class="container">
                <h2 class="page-title">
                    <label for="chkAll">모바일 상품권</label>
                </h2>
                <ul class="prod-list">
                  <li class="clearfix" v-for="(giftItem) in mobileGiftItems">
                    <div class="menu-info">
                      <input type="checkbox" :id="giftItem.externalGiftNo" :value="giftItem" v-model="selectedMobileGiftItems">
                      <label :for="giftItem.externalGiftNo"><span class="blind">선택</span></label>
                      <div class="prod-img">
                        <img :src="getImage(giftItem.productImage)" alt="">
                      </div>
                      <div class="prod-info">
                        <p class="prod-name">{{giftItem.externalGiftName}}</p>
                        <p class="prod-price">{{giftItem.balance |toCurrency}} 원</p>
                      </div>
                    </div>
                    <div class="egift-info01">
                      <div class="clearfix">
                        <span class="txt-egift01 f-left">상품권 번호</span>
                        <span class="txt-egift02 f-right">{{giftItem.externalGiftNo}}</span>
                      </div>
                      <div class="clearfix mt20">
                        <span class="txt-egift01 f-left">유효기간</span>
                        <span class="txt-egift02 f-right">{{giftItem.endDt}} 까지</span>
                      </div>
                    </div>
                  </li>
                  <li v-if="mobileGiftItems.length === 0" class="pt90 t-center pb90">
                        <button type="button" class="btn btn-full btn-gray btn-primary center" style="width:65%;border-radius:8px;display: inline" @click="addGift">상품권 추가하기</button>
                  </li>
                </ul>
                <p class="egift-info">
                    총 결제금액이 적용하려는 모바일 상품권 금액과 같거나 많은 경우에<br>
                    사용이 가능합니다.
                </p>
            </div>
            <!--결제금액 -->
            <div class="payment mt20">
              <!--210121 mt180 클래스 추가 -->
              <div class="clearfix">
                <div class="f-left"><span>총 주문 금액</span></div>
                <div class="f-right"><span class="amount">{{totPrice | toCurrency}} 원</span></div>
              </div>
              <div class="clearfix">
                <div class="f-left"><span>총 할인 금액</span></div>
                <div class="f-right"><span class="amount fc-primary">{{discountPrice | toCurrency}} 원</span></div>
              </div>
              <div class="clearfix">
                <div class="f-left"><span>멤버십 e-Gift 사용</span></div>
                <div class="f-right"><span class="amount fc-info">{{egiftPrice | toCurrency}} 원</span></div>
              </div>
              <div class="clearfix">
                <div class="f-left"><span>모바일 상품권 사용</span></div>
                <div class="f-right"><span class="amount fc-info">{{mobileGiftPrice | toCurrency}} 원</span></div>
              </div>
                <div class="clearfix">
                    <div class="f-left"><span>컵 보증금</span></div>
                    <div class="f-right"><span class="amount">{{totalCupPrice | toCurrency}} 원</span></div>
                </div>
              <div class="total clearfix">
                <div class="f-left"><span>총 결제금액</span></div>
                <div class="f-right"><span class="fc-primary">{{payPrice+totalCupPrice | toCurrency}} 원</span></div>
                  <br>
                  <br>
                      <div class="f-left"><span>상품권 사용 가능 금액</span></div>
                      <div class="f-right"><span class="fc-primary">{{payPrice | toCurrency}} 원</span></div>
              </div>
            </div>
            <!--//결제금액 -->

            <div class="container">
                <ul class="ul-info02">
                    <li>상품권 사용 가능 금액은 컵보증금을 제외한 금액입니다. </li>
                    <li>사용하지 않은 모바일 상품권은 별도 저장되지 않습니다.</li>
                    <li>사용하지 않은 모바일 상품권은 앱에서 다시 추가하거나<br>매장에서 사용할 수 있습니다.</li>
                    <li>모바일 상품권 메뉴의 구매가 어려운 경우 동일 가격 이상의<br>타 메뉴로 변경 가능합니다.<br>
                        (모바일 상품권보다 높은 금액의 경우 추가 금액이 발생할 수<br>있습니다.)
                    </li>
                    <li>모바일 상품권은 매장에서 현금으로 교환되지 않으며 별도<br>거래될 수 없습니다.</li>
                </ul>
            </div>
            <ul class="footer-bottom type02">
                <li>
                    <button type="button" class="btn btn-full btn-gray" style="width:100%;border-radius:0;" @click="addGift">상품권 추가하기</button>
                </li>
                <li>
                    <button type="button" class="btn btn-full btn-primary" style="width:100%;border-radius:0;" @click="applyMobileGift">적용하기</button>
                </li>
            </ul>
        </div>
    </main>
    <custom-modal name="SelectMobileGiftAddDialog" transition="slide">
      <select-mobile-gift-add-dialog  />
    </custom-modal>
</div>
</template>

<script>
import { OrderConfig } from '@/store/Constraints';
import SelectMobileGiftAddDialog from './SelectMobileGiftAddDialog.vue';
export default {
    components: {  SelectMobileGiftAddDialog },
    props: [ 'totPrice', 'discountPrice','totalCupPrice', 'selectedEGiftItems', 'selectedMobileGiftItem' ],
    data() {
        return {
            selectedMobileGiftItems:[],
            mobileGiftItems:[],
        }
    },

    mounted() {
        this.mobileGiftItems = this.$store.getters[OrderConfig.EXTERNAL_GIFTS_RESULT];
        this.selectedMobileGiftItems = this.selectedMobileGiftItem;
        if(this.mobileGiftItems.length === 0){
            this.$modal.show('SelectMobileGiftAddDialog');
        }

    },

    computed: {
        payPrice() {
            let price = this.totPrice - this.discountPrice - this.egiftPrice - this.mobileGiftPrice;
            return price < 0 ? 0 : price;
        },
        egiftPrice(){
            let discountValue = 0;
            this.selectedEGiftItems.forEach(item => {

                if (item.discountType == 'P') { //PERCENT
                    if(item.discountValue > 100){
                        discountValue += item.discountValue;
                        console.log(`SelectEGiftDialog.computed.totalDiscountPrice -> discountValue : ${discountValue}`);
                        return discountValue;
                    }
                    discountValue += this.totalOrderPrice * (this.selectedEGiftItems.discountValue / 100)
                } else if (item.discountType == 'V') { //VALUE
                    discountValue += item.discountValue;
                }
            })

            return discountValue;
        },
        order() {
            return this.$store.getters[OrderConfig.ORDER_DATA].order;
        },
        orderResult() {
            return this.$store.getters[OrderConfig.ORDER_DATA].order.orderResult;
        },
        remainPrice() {
            return this.totPrice - this.discountPrice - this.egiftPrice;
        },
        mobileGiftPrice(){
            let mobileGiftPrice = 0;
            this.selectedMobileGiftItems.forEach(item => {
              mobileGiftPrice += item.balance;
            })
            return mobileGiftPrice;
        }
    },
    watch: {
        selectedMobileGiftItems(value){

            if (this.remainPrice - this.mobileGiftPrice < 0) {
                this.showAlert("모바일 상품권 사용은\n총 결제금액보다 적은 금액만\n선택 가능합니다.", () => {
                    this.selectedMobileGiftItems.pop();
                });
            }
        },
    },
    methods: {
        applyMobileGift() {
            if (this.remainPrice - this.mobileGiftPrice < 0) {
                this.showAlert("모바일 상품권 사용은\n총 결제금액보다 적은 금액만\n선택 가능합니다.")
            }else{
                if(this.selectedMobileGiftItems.length === 0){
                    this.showConfirm('상품권을 사용하지 않고\n계속 주문 하시겠습니까?',
                        ()=>{
                            this.order.orderResult.selectedMobileGiftItems = this.selectedMobileGiftItems;
                            this.$store.commit(OrderConfig.ORDER_DATA, this.order);
                            this.$router.go(-1);
                        },
                        ()=>{

                        },
                        '예',
                        '아니요'
                    );
                }else{
                    this.order.orderResult.selectedMobileGiftItems = this.selectedMobileGiftItems;
                    this.$store.commit(OrderConfig.ORDER_DATA, this.order);
                    this.$router.go(-1);
                }
            }
        },
        getImage: function (image) {
            console.log(image)
            return image && image.indexOf("http") >= 0 ? image : require('@/assets/img/img-menu01.png');
        },
        addGift(){
          // this.$router.push('/order/mobileGift/add')
          this.$modal.show('SelectMobileGiftAddDialog');
        }
    }
}
</script>




// WEBPACK FOOTER //
// src/components/order/SelectMobileGiftDialog.vue